"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

require("core-js/modules/es6.object.freeze");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

/**
 * @package
 * A class to represent the the options that are passed to an xAxisLabelFormatter or yAxisLabelFormatter
 * @param {object} options - Internal use
 *
 * @property {boolean} isFirst true if label is first label on the chart
 * @property {boolean} isLast true if label is last label on the chart
 * @property {number|string} value value for the label
 *
 */
var AxisLabelFormatterOptions = function AxisLabelFormatterOptions(_ref) {
  var isFirst = _ref.isFirst,
      isLast = _ref.isLast,
      value = _ref.value;
  (0, _classCallCheck2.default)(this, AxisLabelFormatterOptions);
  this.isFirst = Boolean(isFirst);
  this.isLast = Boolean(isLast);

  if (typeof value === 'number') {
    this.value = value;
  } else {
    this.value = value || '';
  }

  Object.freeze(this);
};

exports.default = AxisLabelFormatterOptions;